// extracted by mini-css-extract-plugin
module.exports = {"table":"Table_table__2aAfq","center":"Table_center__2I6Ht","right":"Table_right__2RCHi","fill":"Table_fill__2xuHF","footerHeader":"Table_footerHeader__2r3dP"};